/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';
import { call, delay, put, takeLatest } from 'redux-saga/effects';

import api from '../../api/api';
import { errorHandling } from '../../api/errorHandling';
import * as commonSagas from '../_common/commonSagas';
import * as weightingsSlice from './weightingsSlice';
import { Weighting, WeightingPicture } from './weightingsSlice';

// Get weighting by ID
function* getWeightingSaga(props: { type: string; payload: number }) {
 try {
  const response: AxiosResponse<Weighting> = yield call(
   api.get,
   `/Weightings/v1/${props.payload}`,
  );

  yield put(weightingsSlice.getWeightingSuccess(response.data));
 } catch (error: unknown) {
  yield* errorHandling(error, weightingsSlice.getWeightingFailure);
 }
}

// Create weighting
function* createWeightingSaga(props: {
 type: string;
 payload: Partial<Weighting>;
}) {
 try {
  const response: AxiosResponse<Weighting> = yield call(
   api.post,
   `/Weightings/v1`,
   props.payload,
  );

  yield put(weightingsSlice.createWeightingSuccess(response.data));
 } catch (error: unknown) {
  yield* errorHandling(error, weightingsSlice.createWeightingFailure);
 }
}

// Update weighting
function* updateWeightingSaga(props: {
 type: string;
 payload: { id: number; data: Partial<Weighting> };
}) {
 try {
  const response: AxiosResponse<Weighting> = yield call(
   api.put,
   `/Weightings/v1/update/${props.payload.id}`,
   props.payload.data,
  );

  yield put(weightingsSlice.updateWeightingSuccess(response.data));
 } catch (error: unknown) {
  yield* errorHandling(error, weightingsSlice.updateWeightingFailure);
 }
}

// Delete weighting
function* deleteWeightingSaga(props: { type: string; payload: number }) {
 try {
  yield call(api.del, `/Weightings/v1/${props.payload}`);

  yield put(weightingsSlice.deleteWeightingSuccess(props.payload));
 } catch (error: unknown) {
  yield* errorHandling(error, weightingsSlice.deleteWeightingFailure);
 }
}

// Get weighting pictures
function* getWeightingPicturesSaga(props: { type: string; payload: number }) {
 try {
  const response: AxiosResponse<WeightingPicture[]> = yield call(
   api.get,
   `/Weightings/v1/${props.payload}/pictures`,
  );

  yield put(weightingsSlice.getWeightingPicturesSuccess(response.data));
 } catch (error: unknown) {
  yield* errorHandling(error, weightingsSlice.getWeightingPicturesFailure);
 }
}

// Upload weighting pictures
function* uploadWeightingPicturesSaga(props: {
 type: string;
 payload: { weighingId: number; files: FileList };
}) {
 try {
  const formData = new FormData();
  Array.from(props.payload.files).forEach((file) => {
   formData.append('files', file);
  });

  const response: AxiosResponse<WeightingPicture[]> = yield call(
   api.post,
   `/Weightings/v1/pictures/upload/${props.payload.weighingId}`,
   formData,
   //    {
   //     headers: {
   //      'Content-Type': 'multipart/form-data',
   //     },
   //    },
  );
  yield delay(0);
  yield put(weightingsSlice.uploadWeightingPicturesSuccess(response.data));
 } catch (error: unknown) {
  yield* errorHandling(error, weightingsSlice.uploadWeightingPicturesFailure);
 }
}

// Delete weighting picture
function* deleteWeightingPictureSaga(props: { type: string; payload: number }) {
 try {
  yield call(api.del, `/Weightings/v1/pictures/delete/${props.payload}`);

  yield delay(0);
  yield put(weightingsSlice.deleteWeightingPictureSuccess(props.payload));
 } catch (error: unknown) {
  yield* errorHandling(error, weightingsSlice.deleteWeightingPictureFailure);
 }
}

export default function* watchWeightingsSaga() {
 // Common sagas
 yield takeLatest(weightingsSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(weightingsSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(weightingsSlice.createItemStart.type, commonSagas.createItem);
 yield takeLatest(weightingsSlice.updateItemStart.type, commonSagas.updateItem);
 yield takeLatest(weightingsSlice.deleteItemsStart.type, commonSagas.deleteItems);
 yield takeLatest(weightingsSlice.deleteItemStart.type, commonSagas.deleteItem);
 yield takeLatest(
  weightingsSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  weightingsSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  weightingsSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  weightingsSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );

 // Weighting specific sagas
 yield takeLatest(weightingsSlice.getWeightingStart.type, getWeightingSaga);
 yield takeLatest(
  weightingsSlice.createWeightingStart.type,
  createWeightingSaga,
 );
 yield takeLatest(
  weightingsSlice.updateWeightingStart.type,
  updateWeightingSaga,
 );
 yield takeLatest(
  weightingsSlice.deleteWeightingStart.type,
  deleteWeightingSaga,
 );
 yield takeLatest(
  weightingsSlice.getWeightingPicturesStart.type,
  getWeightingPicturesSaga,
 );
 yield takeLatest(
  weightingsSlice.uploadWeightingPicturesStart.type,
  uploadWeightingPicturesSaga,
 );
 yield takeLatest(
  weightingsSlice.deleteWeightingPictureStart.type,
  deleteWeightingPictureSaga,
 );
}
